import { Stack } from "@mui/material"
import React from "react"

import { IdBlock } from "./IdBlock"
import { TokenAvatar } from "./TokenAvatar"
import { truncateId } from "../utils/data-utils"
import { useTokenInfo } from "@/hooks/use-token-info"

type TokenBlockProps = {
  tokenId: string
  hideCopyToClipboard?: boolean
}

export function TokenBlock(props: TokenBlockProps) {
  const { tokenId, hideCopyToClipboard } = props

  const [tokenInfo] = useTokenInfo(tokenId)

  return (
    <>
      <Stack direction="row" gap={1} alignItems="center">
        <TokenAvatar tokenId={tokenId} />
        <IdBlock
          label={tokenInfo?.ticker || truncateId(tokenId)}
          value={tokenId}
          href={`https://ao.link/#/token/${tokenId}`}
          hideCopyToClipboard={hideCopyToClipboard}
        />
      </Stack>
    </>
  )
}
